"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { stripLocaleFromPathname } from "@/lib/i18n/routing";
import { isPublicLocalePathname } from "@/lib/i18n/public-routes";

const APP_SIDEBAR_ROUTE_PREFIXES = [
  "/home",
  "/create",
  "/builder",
  "/dashboard",
  "/import",
  "/parser",
  "/find",
  "/interview",
  "/apply",
  "/settings",
] as const;

const isAppSidebarRoute = (pathname: string) =>
  APP_SIDEBAR_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

const Sidebar = dynamic(() =>
  import("../_components/Sidebar").then((module) => module.Sidebar)
);

export default function SidebarLoader() {
  const pathname = usePathname() ?? "/";
  const normalizedPathname = stripLocaleFromPathname(pathname).pathnameWithoutLocale;

  if (
    normalizedPathname === "/" ||
    (!isPublicLocalePathname(normalizedPathname) &&
      !isAppSidebarRoute(normalizedPathname))
  ) {
    return null;
  }

  return <Sidebar />;
}
